export enum CompModulesStatusEnum {
  COMP_MODULES = 'comp-modules/get',
}



// WEBPACK FOOTER //
// ./src/services/api/comp-modules/types.ts